import * as L from "lonna"
import * as uuid from "uuid"
import { Board, Item } from "../../../common/src/domain"
import { Dispatch } from "../store/board-store"
import { BoardFocus, getSelectedItems } from "./board-focus"
import { installKeyboardShortcut, plainKey } from "./keyboard-shortcuts"

// ponytail: per-browser voter id; good enough for dot voting, swap for user id if/when auth is required
export const VOTER_ID: string = localStorage.voterId ?? (localStorage.voterId = uuid.v4())

export const voteCount = (i: Item) => Object.values(i.votes ?? {}).reduce((a, b) => a + b, 0)
export const myVotes = (i: Item) => i.votes?.[VOTER_ID] ?? 0

export function voteOn(board: Board, items: Item[], delta: 1 | -1, dispatch: Dispatch) {
    const updates = items
        .filter((i) => i.type === "note" || i.type === "text")
        .filter((i) => delta > 0 || myVotes(i) > 0)
        .map((i) => {
            const votes = { ...(i.votes ?? {}) }
            const next = myVotes(i) + delta
            if (next > 0) votes[VOTER_ID] = next
            else delete votes[VOTER_ID]
            return { id: i.id, votes }
        })
    if (updates.length) dispatch({ action: "item.update", boardId: board.id, items: updates })
}

export function itemVoteHandler(board: L.Property<Board>, focus: L.Property<BoardFocus>, dispatch: Dispatch) {
    const selected = () => getSelectedItems(board.get())(focus.get())
    installKeyboardShortcut(plainKey("v"), () => voteOn(board.get(), selected(), 1, dispatch))
    installKeyboardShortcut(
        (e) => e.key === "V" && e.shiftKey && !e.metaKey && !e.ctrlKey && !e.altKey,
        () => voteOn(board.get(), selected(), -1, dispatch),
    )
}
